import { render, staticRenderFns } from "./serveDetails.vue?vue&type=template&id=7170971c&scoped=true&"
import script from "./serveDetails.vue?vue&type=script&lang=js&"
export * from "./serveDetails.vue?vue&type=script&lang=js&"
import style0 from "./serveDetails.vue?vue&type=style&index=0&id=7170971c&lang=scss&scoped=true&"
import style1 from "./serveDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7170971c",
  null
  
)

export default component.exports